import { apiGet } from "../../helpers/ApiHelper";

export const FLUSH_CURRENCY_LOADING = 'FLUSH_CURRENCY_LOADING';
export const FLUSH_CURRENCY_LOADED = 'FLUSH_CURRENCY_LOADED';
export const FLUSH_CURRENCY_ERROR = 'FLUSH_CURRENCY_ERROR';

export const flushCurrency = (chain = 1, address) => {
    return apiGet(`v2/currency/flush/${chain}`, { contract_addresses: address },
        [FLUSH_CURRENCY_LOADING, FLUSH_CURRENCY_LOADED, FLUSH_CURRENCY_ERROR]);
};

const ACTION_HANDLERS = {
    [FLUSH_CURRENCY_LOADING] : (state, action)=>{
        return {
            ...state,
            flushLoading : true,
            flushLoaded : false,
            flushError: false,
            flushErrorMsg : ''
        }
    },
    [FLUSH_CURRENCY_LOADED] : (state, action)=>{
        return {
            ...state,
            flushLoading : false,
            flushLoaded : true,
            flushError : false,
            flushData : action.payload.data,
            flushErrorMsg : ''
        }
    },
    [FLUSH_CURRENCY_ERROR] : (state, action)=>{
        return {
            ...state,
            flushLoading : false,
            flushLoaded : false,
            flushError : true,
            flushData : undefined,
            flushErrorMsg : action.payload.msg
        }
    },
};

const initialState = {
    
    flushLoading : false,
    flushLoaded : false,
    flushError : false,
    flushData : undefined,
    flushErrorMsg : '',

};

export default function noticeReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
};